import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { AxiosError } from 'axios';
import {
  ErrorResponse,
  GetIssuesQuery,
} from '@hud/portal-dtos/src/lib/webapp-common.dto';
import { IssuesResponse } from '@hud/portal-dtos/issues-v2.dtos';
import { ISSUES_BASE } from '../consts';

export const ISSUES_ID = 'issues';

export default function useIssues(params: GetIssuesQuery) {
  const { client, isReady } = useClient();
  return useQuery<IssuesResponse, AxiosError<ErrorResponse>>({
    queryKey: [ISSUES_ID, params],
    queryFn: async () => {
      try {
        const response = await client.get<IssuesResponse>(`${ISSUES_BASE}/v2`, {
          params,
        });
        return IssuesResponse.parse(response.data);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    enabled: isReady && !!params.environmentName,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
